((HoverText, $) => {
  'use strict';

  let $body;

  const cacheDom = () => {
    $body = $('body');
  };

  const desktopToggle = ($this, visibility) => {
    const windowWidth = $(window).width();
    const $text = $this.find('.hover-text-info');
    if (windowWidth > 1024) {
      if (visibility === 'show') {
        $text.slideDown();
      } else {
        $text.slideUp();
      }
    }
  };

  const bindUIActions = () => {
    $body.delegate('.line-item, .cart-item', 'mouseover', function () {
      desktopToggle($(this), 'show');
    });

    $body.delegate('.line-item, .cart-item', 'mouseleave', function () {
      desktopToggle($(this), 'hide');
    });

    $body.delegate('.line-item .cart-display-text, .cart-item .cart-display-text', 'touchstart, click', function () {
      const windowWidth = $(window).width();
      if (windowWidth < 1025) {
        $(this).closest('.line-item, .cart-item').find('.hover-text-info').slideToggle();
      }
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  HoverText.init = init;
})(window.HoverText = window.HoverText || {}, jQuery);
